import { subscribeToAudioLevels } from '@/tauri/events/audio-levels';
import { useEffect } from 'react';

/**
 * Keep the shared `AUDIO_LEVELS` listener alive for as long as this component
 * is mounted (and `enabled`).
 *
 * Every reader of `tauriAudioLevelsAtom` must call this — the listener only
 * exists while at least one consumer holds it, so a bar component that reads
 * the atom without subscribing renders flat.
 *
 * @param enabled Hold the subscription. Pass the consumer's own active
 * condition (e.g. the dictation widget's `isListening`) so the listener is
 * released while the consumer is mounted but idle.
 */
export function useAudioLevelsSubscription(enabled = true): void {
  useEffect(() => {
    if (!enabled) return;
    return subscribeToAudioLevels();
  }, [enabled]);
}
